// extracted by mini-css-extract-plugin
export default {"item":"Inputlist_item__w4ttu","deleteButton":"Inputlist_deleteButton__pbJwO"};